var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 36",
        fill: "none",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.3477", cy: "18", r: "18", fill: "#91C08D" },
      }),
      _c("path", {
        attrs: {
          d: "M26.1972 28.6548H11.2718C11.0657 28.6548 10.8984 28.4878 10.8984 28.2819V6.63979C10.8984 6.43386 11.0657 6.2666 11.2718 6.2666H22.8388C22.9378 6.2666 23.0329 6.30596 23.1029 6.37592L26.4611 9.73417C26.5311 9.80441 26.5704 9.89924 26.5704 9.99804V28.2819C26.5704 28.4878 26.4032 28.6548 26.1972 28.6548ZM11.6448 27.9086H25.8242V10.1525L22.6844 7.01283H11.6448V27.9086Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M26.2002 10.3711H22.8418C22.6359 10.3711 22.4688 10.2041 22.4688 9.99802V6.63977C22.4688 6.48905 22.5599 6.35281 22.699 6.29501C22.8381 6.2372 22.9989 6.26932 23.1058 6.3759L26.4641 9.73415C26.5706 9.84088 26.6028 10.0013 26.545 10.1408C26.4871 10.2801 26.3513 10.3711 26.2002 10.3711ZM23.2151 9.62484H25.2994L23.2151 7.54041V9.62484Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M26.1972 28.6555H11.2718C11.0657 28.6555 10.8984 28.4885 10.8984 28.2826V21.5659C10.8984 21.36 11.0657 21.1929 11.2718 21.1929H26.1972C26.4032 21.1929 26.5704 21.36 26.5704 21.5659V28.2826C26.5704 28.4885 26.4032 28.6555 26.1972 28.6555ZM11.6448 27.9092H25.8242V21.9391H11.6448V27.9092Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.8542 27.1622H17.6155C17.4094 27.1622 17.2422 26.9953 17.2422 26.7892C17.2422 26.5833 17.4094 26.416 17.6155 26.416H19.8542C20.0603 26.416 20.2275 26.5833 20.2275 26.7892C20.2275 26.9953 20.0603 27.1622 19.8542 27.1622Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.6155 27.1626C17.4094 27.1626 17.2422 26.9956 17.2422 26.7895V23.0581C17.2422 22.8522 17.4094 22.6851 17.6155 22.6851C17.8214 22.6851 17.9886 22.8522 17.9886 23.0581V26.7895C17.9886 26.9956 17.8214 27.1626 17.6155 27.1626Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4989 13.7291H13.5138C13.3079 13.7291 13.1406 13.5618 13.1406 13.356V11.8633C13.1406 11.6575 13.3079 11.4902 13.5138 11.4902H16.4989C16.7049 11.4902 16.8722 11.6575 16.8722 11.8633V13.356C16.8722 13.5618 16.7049 13.7291 16.4989 13.7291ZM13.8869 12.9827H16.1258V12.2365H13.8869V12.9827Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4989 15.2222H13.5138C13.3079 15.2222 13.1406 15.0553 13.1406 14.8492V13.3567C13.1406 13.1507 13.3079 12.9834 13.5138 12.9834H16.4989C16.7049 12.9834 16.8722 13.1507 16.8722 13.3567V14.8492C16.8722 15.0553 16.7049 15.2222 16.4989 15.2222ZM13.8869 14.476H16.1258V13.7298H13.8869V14.476Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.9609 15.2222H16.498C16.2921 15.2222 16.125 15.0553 16.125 14.8492V13.3567C16.125 13.1507 16.2921 12.9834 16.498 12.9834H23.9609C24.1669 12.9834 24.334 13.1507 24.334 13.3567V14.8492C24.334 15.0553 24.1669 15.2222 23.9609 15.2222ZM16.8714 14.476H23.5877V13.7298H16.8714V14.476Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4989 16.7139H13.5138C13.3079 16.7139 13.1406 16.5468 13.1406 16.3409V14.8483C13.1406 14.6424 13.3079 14.4751 13.5138 14.4751H16.4989C16.7049 14.4751 16.8722 14.6424 16.8722 14.8483V16.3409C16.8722 16.5468 16.7049 16.7139 16.4989 16.7139ZM13.8869 15.9676H16.1258V15.2213H13.8869V15.9676Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.9609 16.7139H16.498C16.2921 16.7139 16.125 16.5468 16.125 16.3409V14.8483C16.125 14.6424 16.2921 14.4751 16.498 14.4751H23.9609C24.1669 14.4751 24.334 14.6424 24.334 14.8483V16.3409C24.334 16.5468 24.1669 16.7139 23.9609 16.7139ZM16.8714 15.9676H23.5877V15.2213H16.8714V15.9676Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4989 18.2076H13.5138C13.3079 18.2076 13.1406 18.0405 13.1406 17.8345V16.3421C13.1406 16.136 13.3079 15.9688 13.5138 15.9688H16.4989C16.7049 15.9688 16.8722 16.136 16.8722 16.3421V17.8345C16.8722 18.0405 16.7049 18.2076 16.4989 18.2076ZM13.8869 17.4614H16.1258V16.7151H13.8869V17.4614Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.9609 18.2076H16.498C16.2921 18.2076 16.125 18.0405 16.125 17.8345V16.3421C16.125 16.136 16.2921 15.9688 16.498 15.9688H23.9609C24.1669 15.9688 24.334 16.136 24.334 16.3421V17.8345C24.334 18.0405 24.1669 18.2076 23.9609 18.2076ZM16.8714 17.4614H23.5877V16.7151H16.8714V17.4614Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4989 19.6999H13.5138C13.3079 19.6999 13.1406 19.5327 13.1406 19.3266V17.8341C13.1406 17.6282 13.3079 17.4609 13.5138 17.4609H16.4989C16.7049 17.4609 16.8722 17.6282 16.8722 17.8341V19.3266C16.8722 19.5327 16.7049 19.6999 16.4989 19.6999ZM13.8869 18.9535H16.1258V18.2072H13.8869V18.9535Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.9609 19.6999H16.498C16.2921 19.6999 16.125 19.5327 16.125 19.3266V17.8341C16.125 17.6282 16.2921 17.4609 16.498 17.4609H23.9609C24.1669 17.4609 24.334 17.6282 24.334 17.8341V19.3266C24.334 19.5327 24.1669 19.6999 23.9609 19.6999ZM16.8714 18.9535H23.5877V18.2072H16.8714V18.9535Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.5134 27.1629C13.4479 27.1629 13.3816 27.1458 13.3219 27.1096C13.1451 27.0036 13.0878 26.7745 13.1939 26.5977L15.4327 22.8662C15.5386 22.6895 15.7679 22.6323 15.9446 22.7383C16.1215 22.8442 16.1787 23.0734 16.0726 23.2501L13.8338 26.9817C13.7637 27.0984 13.64 27.1629 13.5134 27.1629Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M15.7529 27.1627C15.6261 27.1627 15.5025 27.0982 15.4327 26.9818L13.1939 23.2503C13.0878 23.0735 13.1451 22.8445 13.3219 22.7385C13.4989 22.6321 13.7279 22.6895 13.8338 22.8665L16.0726 26.5978C16.1787 26.7746 16.1215 27.0039 15.9446 27.1098C15.8845 27.1456 15.8182 27.1627 15.7529 27.1627Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.0269 27.1626H21.7208C21.5149 27.1626 21.3477 26.9956 21.3477 26.7895C21.3477 26.5836 21.5149 26.4164 21.7208 26.4164H23.0269C23.3353 26.4164 23.5865 26.1652 23.5865 25.8567C23.5865 25.5481 23.3353 25.2971 23.0269 25.2971H22.6536C21.9335 25.2971 21.3477 24.7111 21.3477 23.991C21.3477 23.2709 21.9335 22.6851 22.6536 22.6851H23.9597C24.1656 22.6851 24.3327 22.8522 24.3327 23.0581C24.3327 23.264 24.1656 23.4313 23.9597 23.4313H22.6536C22.345 23.4313 22.0939 23.6823 22.0939 23.991C22.0939 24.2996 22.345 24.5507 22.6536 24.5507H23.0269C23.7471 24.5507 24.3327 25.1365 24.3327 25.8567C24.3327 26.5769 23.7471 27.1626 23.0269 27.1626V27.1626Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }